

import { useQuery } from "@tanstack/react-query";
import type { StoreSubscriptionAssignmentView } from "@/lib/api/types";
import { endpoints } from "@/lib/api/endpoints";
import { apiJsonClient } from "@/lib/query/core/api-json-client";
import { queryKeys } from "@/lib/query/core/query-keys";

type UseStoreSubscriptionAssignmentsQueryParams = {
  storeId: string;
};

export function useStoreSubscriptionAssignmentsQuery({
  storeId,
}: UseStoreSubscriptionAssignmentsQueryParams) {
  const query = useQuery({
    queryKey: queryKeys.admin.storeSubscriptionAssignments(storeId),
    queryFn: () =>
      apiJsonClient<StoreSubscriptionAssignmentView[]>(
        endpoints.admin.storeSubscriptionAssignments(storeId),
      ),
    enabled: storeId.length > 0,
  });

  return {
    data: query.data,
    isLoading: query.isLoading,
    error: query.error,
    refetch: query.refetch,
  };
}
